<template>
  <div class="max-w-[1000px] my-8">
    <div class="md:flex gap-7">
      <div class="flex flex-col gap-4 md:gap-0 mb-4">
        <ul v-if="isLoading" class="md:w-[240px] space-y-2">
          <li>
            <Skeleton class="w-full h-[56px]" />
          </li>
          <li>
            <Skeleton class="w-full h-[56px]" />
          </li>
        </ul>
        <div v-else class="md:w-[240px]">
          <Tabs v-model="selectedTab" orientation="vertical">
            <TabsList>
              <TabsIndicator variant="highlight" />
              <TabsTrigger
                v-for="role in roles"
                :key="role.id"
                :value="role.id.toString()"
              >
                <router-link
                  :to="{ name: 'workspace-role', params: { role: role.id } }"
                  class="flex items-center gap-2 p-3 text-neutral-500 hover:text-neutral-100"
                  >{{ role.name }}</router-link
                >
              </TabsTrigger>
              <Protect :permissions="[SYS_PERMISSIONS.SYS_ROLES_MANAGE]">
                <TabsTrigger value="-1">
                  <CreateNewRoleDialog />
                </TabsTrigger>
              </Protect>
            </TabsList>
          </Tabs>
        </div>
      </div>
      <div class="w-full">
        <router-view v-if="$route.params.role" :key="$route.params.role" />
        <div v-else class="text-gray-300 font-bold text-sm mb-4">
          Select a role
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import requests from '@vuex/requests.js';
import { SYS_PERMISSIONS } from '@/constants.js';
import Protect from '@/hoc/Protect.vue';
import { Skeleton } from '@ui/components/skeleton';
import { useRouter } from 'vue-router';
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsIndicator,
} from '@ui/components/tabs';

import { queries } from '@/queries/index.js';
import { useStore } from 'vuex';
import CreateNewRoleDialog from './components/roles/CreateNewRoleDialog.vue';

const router = useRouter();

const selectedTab = computed({
  get() {
    return router.currentRoute.value.params.role?.toString();
  },
  set() {},
});

const store = useStore();

const { isLoading, data: roles } = useQuery({
  queryKey: queries.workspace.roles.queryKey,
  queryFn: async () => {
    const data = await requests.roles.get(store.getters['workspace/getId']);
    if (!router.currentRoute.value.params.role && data.length > 0) {
      router.push({ name: 'workspace-role', params: { role: data[0].id } });
    }
    return data;
  },
});
</script>
